import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../core/api/module';
import { ActionType } from '../../../core/redux/actionType';
import { FeedbackSurveyQuestion } from '../models';


const KEY_ACTION = ActionType.GetSelectedQuestionsRequest;
const ACTIONS    = [
  ActionType.GetSelectedQuestionsRequest,
  ActionType.GetSelectedQuestionsResponse,
  ActionType.GetSelectedQuestionsError,
];


type Payload = FeedbackSurveyQuestion[];

type Meta = {
  projectId: number;
  participantId: number;
};


/**
 * Dispatch this action to get the selected feedback survey questions
 */
export const getSelectedQuestionsAction = (projectId: number, participantId: number) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.GetSelectedQuestions,
  headers:  { 'content-type': 'application/json' },
  body:     state => JSON.stringify({ projectId, participantId, languageId: state.locale.lang.languageId }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, participantId }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['selectedQuestions', `${action.meta.projectId}`], payload, successState);
};


export const getSelectedQuestionsReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
